module.exports = __webpack_public_path__ + "static/img/icon_ryuta.eaa1d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_ryuta.png
// module id = 380
// module chunks = 1